import { Action } from "redux";

export const GET_PRODUCT_SEGMENTS = "GET_PRODUCT_SEGMENTS";


export interface ProductSegmentsAction extends Action<string> {
    productSegments:  string[];
}